import React, { useEffect, useRef, useState } from "react";
import StarIcon from "../../../assets/start_Icon.svg";
import IndiaAI_Logo from "../../../assets/IndiaAI_Logo.png";
import AIchatBot from "../../../assets/ai-chatbot.svg";
import { Button, Image, OverlayTrigger, Tooltip } from "react-bootstrap";
import { chatBotfeedback, chatBotQuery } from "../../../services/apiServices";
import request from "../../../services/requestService";
import sendIcon from "../../../assets/Icon-send.svg";
import startIcon from "../../../assets/star-icon.svg";
// import loadingAI from "../../../assets/loader-svg-ai.svg";
import closeButton from "../../../assets/close-button-ai.svg";
import userIcon from "../../../assets/user-profile.svg";
import AiIcon from "../../../assets/next-gen-AI.svg";
import likeButton from "../../../assets/button-Like.svg";
import dislikeButton from "../../../assets/button-dislike.svg";
import dislikeRed from "../../../assets/dislikeRed.svg";
import likedGreen from "../../../assets/likedGreen.svg";
import optionsM from "../../../assets/optionsM.svg";
import copyText from "../../../assets/copyText.svg";
import leftchat from "../../../assets/left-chatbot-arrow.svg";
import rightchat from "../../../assets/right-chat-arrow.svg";
import copied from "../../../assets/copied.svg";
import { getSessionId, getTimeOfTheGivenDate } from "../../../helper";
import ReactMarkdown from "react-markdown";
import { LoaderAI } from "../LoaderAI";
import remarkGfm from "remark-gfm";
import { Dropdown } from "primereact/dropdown";

const ChatbotMarkdownTable = ({ children }) => {
  const tableRef = useRef(null);

  const topTrackRef = useRef(null);
  const bottomTrackRef = useRef(null);

  const [thumbWidth, setThumbWidth] = useState(25);
  const [thumbLeft, setThumbLeft] = useState(0);

  const updateScrollbar = () => {
    const table = tableRef.current;

    if (!table) return;

    const maxScroll = table.scrollWidth - table.clientWidth;

    if (maxScroll <= 0) {
      setThumbWidth(100);
      setThumbLeft(0);
      return;
    }

    const visiblePercentage = (table.clientWidth / table.scrollWidth) * 100;

    const scrollPercentage = (table.scrollLeft / maxScroll) * 100;

    const availableSpace = 100 - visiblePercentage;

    setThumbWidth(visiblePercentage);
    setThumbLeft((scrollPercentage / 100) * availableSpace);
  };

  const scrollTable = direction => {
    if (!tableRef.current) return;

    tableRef.current.scrollBy({
      left: direction === "right" ? 150 : -150,
      behavior: "smooth"
    });
  };

  useEffect(() => {
    updateScrollbar();

    window.addEventListener("resize", updateScrollbar);

    return () => {
      window.removeEventListener("resize", updateScrollbar);
    };
  }, []);

  const ScrollBar = ({ trackRef }) => (
    <div className="table-scrollbar-controls">
      <button
        type="button"
        onClick={() => scrollTable("left")}
        style={{ display: "flex", height: "10px", width: "12px" }}
      >
        <Image src={leftchat} />
      </button>

      <div className="scrollbar-track" ref={trackRef}>
        <div
          className="scrollbar-thumb"
          style={{
            width: `${thumbWidth}%`,
            left: `${thumbLeft}%`
          }}
        />
      </div>

      <button
        type="button"
        onClick={() => scrollTable("right")}
        style={{ display: "flex", height: "10px", width: "12px" }}
      >
        <Image src={rightchat} />
      </button>
    </div>
  );

  return (
    <div className="table-container-chatbot" style={{ marginBottom: "10px" }}>
      {/* TOP SCROLLBAR */}
      <ScrollBar trackRef={topTrackRef} />

      {/* TABLE */}
      <div
        className="table-responsive-wrapper"
        ref={tableRef}
        onScroll={updateScrollbar}
        style={{ marginTop: "-10px" }}
      >
        <table className="custom-table-chatbot">{children}</table>
      </div>

      {/* BOTTOM SCROLLBAR */}
      <ScrollBar trackRef={bottomTrackRef} />
    </div>
  );
};

export function AIChatbot({}) {
  const [isOpen, setIsOpen] = useState(false);
  const [query, setQuery] = useState("");
  const [chatbotresponse, setChatBotresponse] = useState("");
  const [loading, setLoading] = useState(false);
  const [queryStarted, setQueryStarted] = useState(false);
  const [messages, setMessages] = useState(() => {
    const savedMessages = localStorage.getItem("chatbot_messages");
    return savedMessages ? JSON.parse(savedMessages) : [];
  });
  const messagesEndRef = useRef(null);
  const [feedback, setFeedback] = useState({});
  const [comment, setComment] = useState("");
  const [feedbackSubmitted, setfeedbackSubmitted] = useState({});
  const feedbackTextareaRef = useRef(null);
  const [isVisible, setIsvisible] = useState(false);
  const [activeFeedbackId, setActiveFeedbackId] = useState(null);
  const [copiedMessageId, setCopiedMessageId] = useState(null);
  const dropdownRef = useRef(null);
  const [feedbackActive, setfeedbackActive] = useState(false);

  const options = [
    { label: "New Chat", value: "1" }
    // { label: "Export as PDF", value: "2" },
    // { label: "Export as TXT", value: "3" }
  ];

  const ToolTip = ({
    text,
    children,
    id,
    containerClass,
    placement = "bottom"
  }) => {
    return (
      <OverlayTrigger
        defaultShow={false}
        placement={placement}
        overlay={
          <Tooltip id={id} className={`quick_filter_tolltip ${containerClass}`}>
            {text || null}
          </Tooltip>
        }
      >
        {children}
      </OverlayTrigger>
    );
  };

  const handleFeedback = (index, type) => {
    setfeedbackSubmitted(false);
    setFeedback(prev => ({
      ...prev,
      [index]: prev[index] === type ? null : type
    }));
    if (type == "dislike") {
      setActiveFeedbackId(index);

      // setTimeout(() => {
      //   feedbackTextareaRef.current.scrollIntoView({
      //     behavior: "smooth",
      //     block: "center"
      //   });
      // }, 100);
    } else {
      setActiveFeedbackId(null);
    }
  };

  const handleMenu = value => {
    if (value == "1") {
      setMessages([]);
      localStorage.removeItem("chatbot_messages");
      sessionStorage.removeItem("chatSessionId");
      setQueryStarted(false);
      setFeedback({});
    }
  };

  const handleCopy = async (text, chatbotReplyId) => {
    try {
      await navigator.clipboard.writeText(text);

      setCopiedMessageId(chatbotReplyId);

      setTimeout(() => {
        setCopiedMessageId(null);
      }, 2000);
    } catch (error) {
      console.log("Copy failed", error);
    }
  };

  const sendMessage = async () => {
    if (!query.trim()) return;

    const userText = query;
    const sessionId = getSessionId();

    // Add user message
    const userMessage = {
      text: userText,
      sender: "user",
      messageTime: new Date()
    };
    setMessages(prev => [...prev, userMessage]);
    setQuery("");

    // Add loading message
    const loadingMessage = {
      text: "Typing...",
      img: <LoaderAI />,
      sender: "ai",
      loading: true
    };
    setMessages(prev => [...prev, loadingMessage]);

    try {
      setLoading(true);
      setQueryStarted(true);
      const payload = {
        query: query,
        sessionId: sessionId
      };
      const response = await request(chatBotQuery(payload));
      if (response.status) {
        const formatted = response.data.data.answer;
        // .replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>") // bold
        // .replace(/\n\n/g, "<br/><br/>");
        setChatBotresponse(formatted);
        setLoading(false);
        setMessages(prev => {
          const updated = [...prev];
          updated.pop(); // remove "Typing..."
          updated.push({
            text: response.data.data.answer, // API response
            sender: "ai",
            chatbotReplyId: response.data.data.chatbotReplyId,
            messageTime: new Date()
          });
          return updated;
        });
      }

      // Replace loading with actual response
    } catch (error) {
      setMessages(prev => {
        const updated = [...prev];
        updated.pop();
        updated.push({
          text: "Something went wrong!",
          sender: "ai"
        });
        return updated;
      });
    }
  };

  useEffect(() => {
    if (!messagesEndRef.current) return;

    messagesEndRef.current.scrollIntoView({
      behavior: "smooth",
      block: "end"
    });

    localStorage.setItem("chatbot_messages", JSON.stringify(messages));
  }, [messages]);

  useEffect(() => {
    if (activeFeedbackId !== null && feedbackTextareaRef.current) {
      feedbackTextareaRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center"
      });
    }
  }, [activeFeedbackId]);

  const handleclose = () => {
    setIsOpen(false);
  };

  const handleFeedbackSend = async (feedbackByUser, chatbotReplyId) => {
    const payload = {
      rating: feedbackByUser || "",
      comment: comment,
      session_id: getSessionId(),
      chatbot_reply_id: chatbotReplyId
    };

    setfeedbackActive(true);

    try {
      const feedback = await request(chatBotfeedback(payload));
      if (feedback.data.status) {
        setfeedbackSubmitted(prev => ({
          ...prev,
          [chatbotReplyId]: true
        }));

        setActiveFeedbackId(null);
        setComment("");
      }
      setTimeout(() => {
        setfeedbackActive(false);
      }, 2000);
    } catch {
      console.log("error");
    }
  };

  return (
    <div
      className="panel"
      style={{
        position: "fixed",
        bottom: ".1rem",
        right: "1.5rem",
        boxShadow: "none",
        marginBottom: "10px",
        background: "none",
        width: "auto",
        zIndex: 999,
        pointerEvents: "none"
      }}
    >
      {/* Chat Window */}
      {isOpen && (
        <div
          className={`container-chatbot card-AI ${isOpen ? "slide-in" : ""}`}
          style={{ pointerEvents: "auto" }}
        >
          <div
            className="ai-header-wrapper"
            style={{
              color: "#fff",
              background:
                "linear-gradient(90deg, #9b2cff 0%, #c11bb6 35%, #d4148e 55%, #6a4bff 80%, #2f5bff 100%)",
              padding: "7px 6px 7px 15px"
            }}
          >
            <div class="ai-header-content" style={{ padding: 0 }}>
              <Image src={StarIcon} alt="Time" />
              <div class="ai-text" style={{ marginLeft: "-10px" }}>
                <div class="ai-title" style={{ fontSize: "16px" }}>
                  PMG-Nex <span className="beta-text">Beta</span>
                </div>
                <div class="ai-subtitle" style={{ fontSize: "11px" }}>
                  PMG's NextGen AI Assistant
                </div>
              </div>
            </div>
            <div
              class="ai-powered-by"
              style={{
                marginLeft: "70px",
                display: "flex",
                flexDirection: "column",
                padding: "0px 10px",
                background: "#fff",
                borderRadius: "4px",
                gap: 0
              }}
            >
              <span class="powered-text" style={{ fontSize: "10px" }}>
                POWERED BY
              </span>
              <Image
                src={IndiaAI_Logo}
                class="ai-logo"
                style={{ height: "26px" }}
              />
            </div>
            <div>
              <Image
                src={optionsM}
                style={{ marginLeft: "6px", cursor: "pointer" }}
                onClick={e => dropdownRef.current.show()}
              />

              <Dropdown
                ref={dropdownRef}
                options={options}
                onChange={e => handleMenu(e.value)}
                className="hidden-dropdown chatbot-menu"
                panelClassName="my-custom-dropdown-panel"
              />
            </div>
            <div style={{ cursor: "pointer" }} onClick={() => handleclose()}>
              <Image src={closeButton} />
            </div>
          </div>

          {messages.length == 0 ? (
            <div style={{ padding: "0 12px" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "40px"
                }}
              >
                <Image src={startIcon} />
              </div>
              <span className="welcome-text">Welcome to the PMG-Nex</span>
              <span className="welcome-subtext">
                I can help you with summarizing project details, issue status,
                updates, and dive into specific insights.
              </span>
              <span className="assist-text">How may I assist you today?</span>
            </div>
          ) : (
            <>
              <div
                className="messages"
                style={{ flex: 1, overflowY: "auto", padding: "12px" }}
              >
                {messages.map((msg, index) => (
                  <div
                    key={index}
                    style={{
                      display: "flex",
                      flexDirection:
                        msg.sender === "user" ? "row-reverse" : "row",
                      alignItems: "flex-start",
                      gap: "8px",
                      marginBottom: "16px"
                    }}
                  >
                    {msg.sender === "user" ? (
                      <div className="user-icon">
                        <Image
                          src={userIcon}
                          alt="You"
                          style={{ width: "32px", height: "32px" }}
                        />
                      </div>
                    ) : (
                      <div
                        style={{
                          borderRadius: "50%",
                          overflow: "hidden",
                          flexShrink: 0
                        }}
                      >
                        <Image
                          src={AiIcon}
                          alt="PMG-Nex"
                          style={{ width: "32px", height: "32px" }}
                        />
                      </div>
                    )}

                    <div style={{ maxWidth: "80%" }}>
                      <div
                        style={{
                          fontSize: "14px",
                          fontFamily: "mpsb",
                          color: "#525252",
                          textAlign: msg.sender === "user" ? "right" : "left"
                        }}
                      >
                        {msg.sender === "user" ? "You" : "PMG-Nex"}
                      </div>

                      {/* Bubble */}
                      <div
                        className="bubble-conversation"
                        style={{
                          borderRadius:
                            msg.sender === "user"
                              ? "16px 4px 16px 16px" // user bubble shape
                              : "4px 16px 16px 16px", // AI bubble shape
                          background:
                            msg.sender === "user"
                              ? "linear-gradient(180deg, #5A8DEE 0%, #3F5BD8 100%)"
                              : "linear-gradient(90deg, rgba(191, 219, 254, 0.80) 0%, rgba(245, 208, 254, 0.80) 100%)",
                          color: msg.sender === "user" ? "#fff" : "#333",
                          fontSize: msg.sender === "user" ? "13px" : "13px"
                        }}
                      >
                        {msg.loading ? (
                          // <Image className="typing-img" src={msg.img} />
                          <LoaderAI />
                        ) : (
                          <>
                            <div className="markdown-content">
                              <ReactMarkdown
                                remarkPlugins={[remarkGfm]}
                                className={` ${
                                  msg.sender === "user" ? "user-message" : ""
                                }`}
                                // components={{
                                //   table: ({ node, ...props }) => (
                                //     <div className="table-responsive-wrapper">
                                //       <table
                                //         className="custom-table-chatbot"
                                //         {...props}
                                //       />
                                //     </div>
                                //   )
                                // }}
                                components={{
                                  table: ({ node, children }) => (
                                    <ChatbotMarkdownTable>
                                      {children}
                                    </ChatbotMarkdownTable>
                                  )
                                }}
                              >
                                {msg.text}
                              </ReactMarkdown>
                            </div>
                            <div
                              style={{
                                fontSize: "11px",
                                textAlign: "right",
                                color:
                                  msg.sender === "user" ? "#fff" : "#7C879A",
                                marginTop: "-10px"
                              }}
                            >
                              {getTimeOfTheGivenDate(msg.messageTime)}
                            </div>
                          </>
                        )}
                      </div>
                      {!msg.loading && msg.sender != "user" && (
                        <div style={{ display: "flex" }}>
                          <span className="was-helpful">Was this helpful?</span>
                          <Image
                            style={{
                              marginLeft: "8px",
                              marginTop: "5px",
                              cursor: "pointer"
                            }}
                            src={
                              feedback[index] === "like"
                                ? likedGreen
                                : likeButton
                            }
                            onClick={() => {
                              const newFeedback =
                                feedback[index] === "like" ? null : "like";

                              setFeedback(prev => ({
                                ...prev,
                                [index]: newFeedback
                              }));
                              handleFeedbackSend(
                                newFeedback,
                                msg.chatbotReplyId
                              );
                            }}
                          />
                          <Image
                            style={{
                              marginLeft: "6px",
                              marginTop: "5px",
                              cursor: "pointer"
                            }}
                            src={
                              feedback[index] === "dislike"
                                ? dislikeRed
                                : dislikeButton
                            }
                            onClick={() => {
                              const newFeedback =
                                feedback[index] === "dislike"
                                  ? null
                                  : "dislike";
                              handleFeedback(index, "dislike");
                              if (newFeedback === "dislike") {
                                setTimeout(() => {
                                  feedbackTextareaRef.current.scrollIntoView({
                                    behavior: "smooth",
                                    block: "center"
                                  });
                                }, 100);
                              }
                            }}
                          />
                          <ToolTip text={"Copy Response"}>
                            <Image
                              src={
                                copiedMessageId !== msg.chatbotReplyId
                                  ? copyText
                                  : copied
                              }
                              style={{ paddingLeft: "8px", paddingTop: "5px" }}
                              onClick={() =>
                                handleCopy(msg.text, msg.chatbotReplyId)
                              }
                            />
                          </ToolTip>
                        </div>
                      )}
                      {msg.sender != "user" &&
                        feedback[index] === "dislike" &&
                        activeFeedbackId === index &&
                        !feedbackSubmitted[msg.chatbotReplyId] && (
                          <div
                            ref={feedbackTextareaRef}
                            index={index}
                            style={{
                              width: "335px",
                              height: "215px",
                              border: "1px solid #E5E7EB",
                              borderRadius: "4px",
                              marginTop: "5px",
                              background: "#F9FAFB"
                            }}
                          >
                            <div className="header-feedback">
                              What went wrong?
                            </div>
                            <div
                              style={{
                                display: "flex",
                                marginLeft: "10px",
                                justifyContent: "space-between",
                                marginRight: "5px"
                              }}
                            >
                              <span
                                className="preselect-feedback"
                                onClick={() =>
                                  setComment("Inaccurate information")
                                }
                                style={{ cursor: "pointer" }}
                              >
                                Inaccurate information
                              </span>
                              <span
                                className="preselect-feedback"
                                onClick={() => setComment("Not helpful")}
                                style={{ cursor: "pointer" }}
                              >
                                Not helpful
                              </span>
                              <span
                                className="preselect-feedback"
                                onClick={() => setComment("Too long")}
                                style={{
                                  marginRight: "5px",
                                  cursor: "pointer"
                                }}
                              >
                                Too long
                              </span>
                            </div>
                            <textarea
                              className="feedback-textarea"
                              placeholder="Additional feedback (optional)"
                              rows="4"
                              value={comment}
                              onChange={e => setComment(e.target.value)}
                            />
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                marginRight: "12px",
                                gap: "10px",
                                marginTop: "5px"
                              }}
                            >
                              <Button
                                style={{
                                  width: "63px",
                                  height: "25px",
                                  fontSize: "11px",
                                  background: "none",
                                  color: "#6B7280",
                                  textTransform: "capitalize",
                                  padding: "2px 5px",
                                  fontFamily: "mpr",
                                  border: "none"
                                }}
                                onClick={() => {
                                  setActiveFeedbackId(null);
                                  setComment("");
                                }}
                              >
                                Cancel
                              </Button>
                              <Button
                                onClick={() =>
                                  handleFeedbackSend(
                                    feedback[index],
                                    msg.chatbotReplyId
                                  )
                                }
                                style={{
                                  width: "110px",
                                  height: "25px",
                                  fontSize: "11px",
                                  padding: "2px 5px",
                                  textTransform: "capitalize",
                                  fontFamily: "mpr"
                                }}
                              >
                                Submit Feedback
                              </Button>
                            </div>
                          </div>
                        )}
                      {msg.sender != "user" &&
                        feedbackActive &&
                        feedbackSubmitted[msg.chatbotReplyId] && (
                          <div
                            ref={feedbackTextareaRef}
                            className="feedback-submitted"
                          >
                            Feedback Submitted
                          </div>
                        )}
                      {/* {msg.sender != "user" && copiedMessageId != null && (
                        <div
                          ref={feedbackTextareaRef}
                          className="feedback-submitted"
                        >
                          Response Copied
                        </div>
                      )} */}
                    </div>
                  </div>
                ))}
                <div ref={messagesEndRef} />
              </div>
            </>
          )}
          <div>
            <input
              placeholder="Type here your message..."
              className="input-box-ai"
              value={query}
              onChange={e => setQuery(e.target.value)}
              onKeyDown={e => {
                if (e.key === "Enter" && !e.shiftKey) {
                  e.preventDefault();
                  sendMessage();
                }
              }}
            />
            <button className="button-ai" onClick={() => sendMessage()}>
              <Image src={sendIcon} />
            </button>
          </div>
          <br />
        </div>
      )}

      {/* Toggle Button */}
      <button
        onClick={() => setIsOpen(true)}
        style={{
          width: "3.5rem",
          height: "3.5rem",
          borderRadius: "50%",
          background: "none",
          color: "#fff",
          border: "none",
          cursor: "pointer",
          float: "right",
          fontSize: "1.5rem",
          pointerEvents: "auto"
        }}
      >
        {/* <Image src={AIchatBot} /> */}
        <div
          className="ai-icon-button active ai-icon-button-tag ai-icon-chatbot"
          style={{
            height: "55px",
            width: "55px",
            right: "0.8rem",
            border: "none",
            bottom: "-5px"
          }}
        >
          <Image
            src={AIchatBot}
            alt="AI Icon"
            style={{
              background: "#fff",
              borderRadius: "50%",
              objectFit: "none",
              height: "47px",
              width: "47px"
            }}
          />
        </div>
      </button>
    </div>
  );
}
